import { useEffect, useState } from "react";
import { bloomsApi } from "../../services/bloomsApi";
import { Card } from "../../components/common/Card";
import { DataTable } from "../../components/common/DataTable";
import { Spinner } from "../../components/common/Spinner";

export function BloomTab({ hive }) {
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    bloomsApi.calendar().then((r) => setMatches(r.bloom_calendar.filter((m) => m.site_id === hive.site_id)));
  }, [hive.site_id]);

  if (!matches) return <Spinner />;

  return (
    <Card title="Nearby Forage & Bloom Dates">
      <DataTable
        rows={matches}
        rowKey="match_id"
        emptyTitle="No bloom matches for this site yet"
        emptyDescription="Run the bloom calendar generator from the Bloom Calendar page for this site."
        columns={[
          { key: "plant_name", header: "Plant" },
          { key: "bloom_start_date", header: "Bloom Start", render: (r) => new Date(r.bloom_start_date).toLocaleDateString() },
          { key: "bloom_end_date", header: "Bloom End", render: (r) => new Date(r.bloom_end_date).toLocaleDateString() },
        ]}
      />
    </Card>
  );
}
